import { render } from "./AttendanceDetails.vue?vue&type=template&id=cb80c426&ts=true"
import script from "./AttendanceDetails.vue?vue&type=script&lang=ts"
export * from "./AttendanceDetails.vue?vue&type=script&lang=ts"

import "./AttendanceDetails.vue?vue&type=style&index=0&id=cb80c426&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__